<template>
    <span>
        <span style="font-size:12px;color:#fff;">Server location</span>
          <v-flex :style="'justify-content: center;' + (disabled? 'pointer-events:none;' : '')">
                       <v-btn
                               style="width:100%;font-size:14px;    justify-content: normal;    padding: 0;"
                               x-large

                               light
                               @click="dialogOpen = true"

                       >
                           <v-icon v-if="selectedServer.mdiIcon" style="margin-left:13px;margin-right:13px;">{{selectedServer.mdiIcon}}</v-icon>
                           <span  v-if="selectedServer.icon" :class="'flag-icon flag-icon-' + selectedServer.icon" style="margin:0 15px;border-radius:3px;"></span>
                           <div style="display:inline-block">{{selectedServer.name}}</div>
                           <v-icon
                                   class="chevron"
                                   large
                                   v-if="!disabled"

                           >
                               mdi-chevron-down
                           </v-icon>
                       </v-btn>
                   </v-flex>
        <v-dialog
                v-model="dialogOpen"
                :attach="insideModal? '#configureDNS_dialog' : false"
                :fullscreen="!insideModal"
                hide-overlay
                transition="dialog-bottom-transition"
        >

                <v-card >
                    <v-toolbar
                            dark
                            color="#444"
                    >
                        <v-btn
                                icon
                                dark
                                @click="dialogOpen = false"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Choose server</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>

                        </v-toolbar-items>
                    </v-toolbar>
                    <v-list  :style="(insideModal? 'max-height: 390px;' : 'max-height: calc(100vh - 56px);') + 'overflow: auto;'">

                        <v-list-item-group
                                v-model="selectedServerIndex"
                                color="primary"
                        >

                            <v-list-item
                                    v-for="(item, i) in serverList"
                                    :key="i"
                            >
                                <v-list-item-icon>
                                      <v-icon v-if="item.mdiIcon" style="margin-left:13px;margin-right:13px;">{{item.mdiIcon}}</v-icon>
                                    <span v-if="item.icon" :class="'flag-icon flag-icon-' + item.icon" style="margin:0 15px;border-radius:2px;"></span>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title v-text="item.name"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card>
            </v-dialog>

    </span>
</template>

<style>

    .chevron {
        position: absolute!important;right:15px;
    }

    .rtl .chevron {
        right:auto;
        left:15px;
        position: absolute!important;
    }

</style>

<script>
    // @ is an alias to /src
    import config from '../../../config';

	export default {
        name: 'Extension_Components_ServerSelection',
        props: ['disabled','connected', 'connectedTo', 'insideModal'],
        async created(){

            this.serverList = this.serverList.concat(await (await fetch(`${config.serverURL}/region/listUI`)).json())


        },
        data: () => ({
            dialogOpen: false,
            serverList: [
                {mdiIcon: 'mdi-auto-fix', name: 'Auto Detect', code: 'AutoDetect'},
            ],
            selectedServerIndex: 0
        }),
        computed: {
            selectedServer(){

                if(!this.connected){
                    return this.serverList[this.selectedServerIndex];
                }else{

                    const connectedTo = this.serverList.find(server => server.code === this.connectedTo);

                    return connectedTo || this.serverList[this.selectedServerIndex];

                }

            }
        },
        watch: {
            selectedServerIndex(){
                this.dialogOpen = false;

                this.$emit('input', this.selectedServer.code);

            }
        }

    }
</script>
